import moment from 'moment';
import { formats } from 'utils/validators';

export const correctlyFormatDate = (date) => {
  let formattedDate;
  const defaultYearParser = moment.parseTwoDigitYear;

  moment.parseTwoDigitYear = (year) => {
    if (moment().format('YY') >= year) {
      return parseInt(year, 10) + 2000;
    }

    return parseInt(year, 10) + 1900;
  };

  const dateObject = moment(date, formats, true);

  if (dateObject.isValid()) {
    formattedDate = dateObject.format('YYYY-MM-DD');
  }

  moment.parseTwoDigitYear = defaultYearParser;

  return formattedDate || date;
};

export const today = (format = 'YYYY-MM-DD') => moment(new Date()).format(format);

export const dateIsWithin24Hours = (date) => {
  const dateIn24Hours = moment().add(1, 'days');

  return moment(date).isBefore(dateIn24Hours);
};

export const isMoreThanXMinutesAgo = (minutes) => (dateTimeIsoString) => {
  const currentTime = moment();
  const dateTime = moment(new Date(dateTimeIsoString));
  const dateTimeInPast = dateTime.subtract(minutes, 'minutes');

  return currentTime.isSameOrBefore(dateTimeInPast);
};

export const isInMoreThanXHoursFromNow = ({ isoDate, hours }) => {
  const currentTime = moment();
  const differenceInHours = moment(isoDate).diff(currentTime, 'hours');

  return differenceInHours > hours;
};

/**
 * Format a date, return the time by default
 *
 * @param {Date} date
 * @param {string} [format="HH:mm"]
 * @returns {string | null}
 */
export const formatTime = (date, format = 'HH:mm') => (date ? moment(date).format(format) : null);
